import React from "react";
import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import MuiIcon from "../../../shared/styles/mui/helpers/mui-icon.helper";
import useRouteHelper from "../../../shared/routes/useRouteHelper.hook";
import LinkButton from "../../../shared/components/link-button/link-button";

interface IProps {
  headerUserName: string;
  headerTenantName: string;
}

function PrivateHeaderComponent({ headerUserName, headerTenantName }: IProps) {
  const { gotoUserPage, gotoQueuedReportsPage, pathname } = useRouteHelper();

  // Split pathname into segments and check relevant part
  const pathSegments = pathname.split("/").filter((segment) => segment); // filters out empty strings from leading slashes
  const isQueuedReportsActive = pathSegments.includes("queued-reports");
  const isReportsAndAnalyticsActive =
    pathSegments.includes("report-list") ||
    pathSegments.some(
      (segment) =>
        segment === "reporting-and-analytics" &&
        !pathSegments.includes("queued-reports")
    );

  return (
    <AppBar color="default" elevation={0} position="static">
      <Toolbar>
        <IconButton size="large" edge="start" color="inherit" sx={{ mr: 2 }}>
          {MuiIcon.MENU()}
        </IconButton>

        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Reports Menu
        </Typography>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {headerUserName}
        </Typography>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {headerTenantName}
        </Typography>

        <LinkButton
          isActive={isQueuedReportsActive}
          onClick={gotoQueuedReportsPage}
        >
          Queued Reports
        </LinkButton>

        <LinkButton
          isActive={isReportsAndAnalyticsActive}
          onClick={gotoUserPage}
        >
          Reporting & Analytics
        </LinkButton>
      </Toolbar>
    </AppBar>
  );
}

export default PrivateHeaderComponent;
